import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IoArrowBackOutline, IoSaveOutline } from 'react-icons/io5';
import Navbar from '../lab/Navbar';
import labService from '../lab/labService';
import '../wallet/css/ManageLicences.css';

const EditModelAdmin = () => {
  const { modelId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    model_name: '',
    version_name: '',
    model_category: '',
    model_price: 0
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const token = JSON.parse(localStorage.getItem('user'))?.access;
      try {
        const response = await labService.getModelDetailsAdmin(modelId, token);
        setFormData({
          model_name: response.data.model_name || '',
          version_name: response.data.version_name || '',
          model_category: response.data.model_category || 'human toxicity',
          model_price: response.data.model_price || 0
        });
      } catch (error) {
        console.error("Error loading model:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [modelId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    const token = JSON.parse(localStorage.getItem('user'))?.access;
    try {
      await labService.updateModelAdmin(modelId, formData, token);
      navigate(`/manage-models/${modelId}`); // wracamy do szczegółów
    } catch (error) {
      alert("Failed to save changes.");
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <div className="spinner"></div>;

  return (
    <div className='lab-container'>
      <Navbar />
      <div className="manage-licenses-container" style={{ padding: '40px' }}>
        <header style={{ display: 'flex', alignItems: 'center', marginBottom: '30px', gap: '20px' }}>
          <IoArrowBackOutline
            className="icon-action-danger"
            style={{ fontSize: '30px', color: '#1B4480' }}
            onClick={() => navigate(-1)}
          />
          <h2 className='h2-title'>Modify Model: {formData.model_name}</h2>
        </header>

        <div style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '8px', border: '1px solid #e2e8f0', maxWidth: '600px' }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Model Name</label>
              <input
                className="search-input"
                style={{ paddingLeft: '15px' }} // usuwamy miejsce na ikonkę lupy
                value={formData.model_name}
                onChange={e => setFormData({ ...formData, model_name: e.target.value })}
                required
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Version</label>
              <input
                className="search-input"
                style={{ paddingLeft: '15px' }}
                value={formData.version_name}
                onChange={e => setFormData({ ...formData, version_name: e.target.value })}
                required
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Category</label>
              <select
                className="search-input"
                style={{ paddingLeft: '15px', height: '45px' }}
                value={formData.model_category}
                onChange={e => setFormData({ ...formData, model_category: e.target.value })}
              >
                <option value="human toxicity">Human Toxicity</option>
                <option value="environmental">Environmental</option>
                <option value="physicochemical properties">Physicochemical Properties</option>
              </select>
            </div>

            {/* <div style={{ marginBottom: '30px' }}> */}
            {/*   <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Price (tokens)</label> */}
            {/*   <input */}
            {/*     type="number" */}
            {/*     className="search-input" */}
            {/*     style={{ paddingLeft: '15px' }} */}
            {/*     value={formData.model_price} */}
            {/*     onChange={e => setFormData({ ...formData, model_price: e.target.value })} */}
            {/*     required */}
            {/*   /> */}
            {/* </div> */}

            <div style={{ display: 'flex', gap: '15px' }}>
              <button type="submit" className="btn btn-primary" disabled={isSaving}>
                <IoSaveOutline size="18px" /> {isSaving ? 'Saving...' : 'Save Changes'}
              </button>
              <button type="button" className="btn btn-neutral" onClick={() => navigate(-1)}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditModelAdmin;
